import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../AuthContext/AuthContext';
import {
  Box,
  Typography,
  Button,
  CircularProgress
} from '@mui/material';

const SubscriptionGuard = ({ children, user_types }) => {
   console.log("user type", user_types);
  const { userId } = useContext(AuthContext);
  const [hasSubscription, setHasSubscription] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkSubscription = async () => {
      try {
        const response = await fetch(`https://landnest.net:81/Get-user-plan/${userId}/`);
        if (!response.ok) throw new Error('Network response was not ok');

        const subscriptions = await response.json();
        console.log("User Subscriptions Data:", subscriptions);

        // ✅ Check if any subscription matches any of the user_types
        const hasValidSubscription =
          Array.isArray(subscriptions) &&
          subscriptions.some(sub => user_types.includes(sub.user_type));

        setHasSubscription(hasValidSubscription);
         if (hasValidSubscription) {
          console.log("User has at least one valid subscription matching the type");
        } else {
          console.log("No valid subscription found for this user type");
        }
      } catch (error) {
        console.error('Error fetching subscription:', error);
        setHasSubscription(false);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      checkSubscription();
    } else {
      setLoading(false);
    }
  }, [userId, user_types]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!hasSubscription) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '90vh',
          pt: '10px',
          backgroundColor: 'rgb(239, 231, 221)',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Typography variant="h6" sx={{ mb: 3 }}>
          You have not Subscribed Yet.
        </Typography>
        <Typography variant="h6" sx={{ mb: 3 }}>
          Please subscribe to access this feature
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button variant="contained" color="primary" onClick={() => navigate('/user-subscription')}>
            Do Subscribe
          </Button>
          <Button variant="outlined" color="primary" onClick={() => navigate(-1)}>
            Back
          </Button>
        </Box>
      </Box>
    );
  }

  return children;
};

export default SubscriptionGuard;